<template>
  <div class="geely-ai">
    <div class="ai-content">
      <img class="ai" src="./images/geelyAI.gif" alt="加载中" @click="toAI()" />
      <!-- 你好我是吉利A，你的智能助手，有 什么问题都可以问我~ -->
      <img
        :class="{ 'show-tip': showTip }"
        class="ai-tip"
        src="./images/ai-bk.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeelyAI',
  data() {
    return {
      showTip: true
    };
  },
  mounted() {
    setTimeout(() => {
      this.showTip = false;
    }, 5000);
  },
  computed: {
    loginUser () {
      console.log(this.$store.state.global.loginInfo);
      return this.$store.state.global.loginInfo
    }
  },
  methods: {
    toAI() {
      let host = '';
      const isMobile = this.$device.isMobile;
      let ticket = this.loginUser ? this.loginUser.ticket : '';

      if (
        process.env.NODE_ENV === 'production'
      ) {
        // 生产环境
        if (isMobile) {
          host = 'agent.geely.com';
        } else {
          host = 'oai.geely.com';
        }
      } else {
        // 测试环境
        if (isMobile) {
          host = 'agent.geely-test.com';
        } else {
          host = 'oai.geely-test.com';
        }
      }
      host &&
        // window.open(
        //   `https://${host}/api/login/success?ticket=${this.$ssoAccessToken}&redirectUrl=https://${host}/geely-ai`
        // );
        window.open(
          `https://${host}/api/login/success` + '?ticket=' + ticket + '&spg_id_token=' + this.loginUser.spg_id_token + '&redirectUrl=' + `https://${host}/geely-ai`, '_blank'
        );
      // url = `https://${host}/api/login/success` + '?ticket=' + ticket + '&spg_id_token=' + this.loginUser.spg_id_token + '&redirectUrl=' + `https://${host}/geely-ai`
    }
  }
};
</script>

<style lang="scss" scoped>
.geely-ai {
  .ai-content {
    position: relative;

    img.ai {
      cursor: pointer;
      display: block;
      float: right;
      height: 64px;
      // margin-bottom: 50px;
      width: 64px;
    }

    img.ai-tip {
      opacity: 0; /* 初始完全透明 */
      position: absolute;
      right: -15px;
      top: -85px;
      transition: opacity 0.5s ease;
    }

    &:hover {
      .ai-tip {
        opacity: 1; /* 完全显示 */
      }
    }

    img.show-tip {
      opacity: 1; /* 完全显示 */
    }
  }
}
</style>
